module.exports = __webpack_public_path__ + "static/page02-1bf07c0a219b7b6f3386abbe25627f28.jpg";